import { render, staticRenderFns } from "./PopupMessage.vue?vue&type=template&id=b5350f5a&scoped=true&"
import script from "./PopupMessage.vue?vue&type=script&lang=js&"
export * from "./PopupMessage.vue?vue&type=script&lang=js&"
import style0 from "./PopupMessage.vue?vue&type=style&index=0&id=b5350f5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b5350f5a",
  null
  
)

export default component.exports